module.exports = __webpack_public_path__ + "static/media/Babalola-Damilola-Frontend-Engineer-Resume.64c6bbbe.pdf";